import { render, staticRenderFns } from "./OrganizationMembers.vue?vue&type=template&id=5bb7f6fe"
import script from "./OrganizationMembers.vue?vue&type=script&lang=js"
export * from "./OrganizationMembers.vue?vue&type=script&lang=js"
import style0 from "./OrganizationMembers.vue?vue&type=style&index=0&id=5bb7f6fe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports